import { RouterDetailsType } from 'router'
import URLPattern from 'url-pattern'

export type URLPatternExtractorType = {
  pattern: string
  url: string
  segmentKey: string
}

/**
 * To transform a react-router-dom path to url-pattern.
 * Why? some regex of react-router-dom path doesn't support in the url-pattern
 *
 * @param route
 * @returns {String}
 */
export const transformReactRouterToUrlPattern = (route: string) =>
  route.replace(/\/:([\w-]+)\?/g, '(/:$1)')

export const URLPatternExtractorSingleSegment = ({
  pattern,
  segmentKey,
  url,
}: URLPatternExtractorType) => {
  const testPattern = new URLPattern(transformReactRouterToUrlPattern(pattern))
  const value = testPattern.match(url) as Record<string, string>

  return value ? value[segmentKey] || null : null
}

export const createRoutePath = (
  pathPattern: RouterDetailsType[keyof RouterDetailsType]['path'],
  params?: Record<string, string | number>,
) => {
  const pattern = new URLPattern(transformReactRouterToUrlPattern(pathPattern))
  return pattern.stringify(params || {})
}
